import { call, options, params } from './helpers';

export const getCustomers = (payload) =>
	call(`/beta/admin/organizations${params(payload)}`);

export const getAllEvents = (payload) =>
	call(`/beta/admin/events${params(payload)}`);

export const getOrganization = (id) => {
	console.log('get :', id);
	return call(`/beta/admin/organization/${id}`);
};
export const updateOrganization = ({ id, ...payload }) => {
	console.log('ID: ', id, payload);
	return call(`/beta/admin/organization/${id}`, options(payload, 'PUT'));
};

export const getAllTasks = (payload) =>
	call(`/beta/admin/tasks${params(payload)}`);

export const getAllAdminServiceReports = (payload) =>
	call(`/beta/admin/service-reports${params(payload)}`);

export const createBlankAdminServiceReport = (payload) =>
	call(`/beta/admin/service-reports`, options(payload, 'POST'));

export const getAdminServiceReport = ({ id }) =>
	call(`/beta/admin/service-reports/${id}`);
export const updateAdminServiceReport = ({ id, ...payload }) =>
	call(`/beta/admin/service-reports/${id}`, options(payload, 'PUT'));

export const createAdminServiceBlocks = (payload) =>
	call(`/beta/admin/service-reports/blocks`, options(payload, 'POST'));

export const updateAdminServiceBlocks = ({ id, ...payload }) =>
	call(`/beta/admin/service-reports/blocks/${id}`, options(payload, 'PUT'));

export const deleteAdminServiceBlock = ({ id }) =>
	call(`/beta/admin/service-reports/blocks/${id}`, options(null, 'DELETE'));

export const getAllAdminServiceBlocks = (payload) =>
	call(`/beta/admin/service-reports/blocks${params(payload)}`);

export const betaCreateOrganization = (payload) =>
	call(`/beta/admin/initialize`, options(payload, 'POST'));

export const getAssetsAdmin = (id) =>
	call(`/beta/admin/organization/${id}/assets`);

export const getOrganizationUsers = (id) =>
	call(`/beta/admin/organization/${id}/users`);

export const getOrganizationServiceReports = (id) =>
	call(`/beta/admin/organization/${id}/service-reports`);

export const getChildOrganizations = (id) =>
	call(`/beta/admin/organization/${id}/children`);

export const uploadServiceReportImages = ({ id, files }) =>
	call(
		`/beta/admin/service-reports/${id}/images`,
		options({ files, bucket: 'service-reports', information: {} }, 'POST'),
	);

// Admin API Tokens
export const getAdminApiTokens = (organizationId) =>
	call(`/beta/admin/organization/${organizationId}/api-tokens`);

export const createAdminApiToken = ({ organizationId, ...payload }) =>
	call(
		`/beta/admin/organization/${organizationId}/api-tokens`,
		options(payload, 'POST'),
	);

export const revokeAdminApiToken = ({ organizationId, tokenId }) =>
	call(
		`/beta/admin/organization/${organizationId}/api-tokens/${tokenId}`,
		options(null, 'DELETE'),
	);

export const getAdminApiTokenScopes = () =>
	call(`/beta/admin/api-tokens/scopes`);
